<template>
  <div class="sidebar-wrapper" :class="{ 'minimized': isMinimized, 'mobile-menu-open': mobileMenuOpen }" :style="{'--brand-color': color}">
    <div class="sidebar" :style="sidebarColor">
      <!-- Logo Section -->
      <div class="sidebar-header">
        <div class="logo-container" @click="goToDashboard">
        <img
          v-if="getUserSystem == 'ULU'"
          class="sidebar-logo"
          src="@/assets/uluLogo.png"
          alt="ULU logo"
        />
        <img
          v-else-if="getUserSystem == 'ulubv'"
          class="sidebar-logo"
          src="@/assets/ulubv_logo.png"
          alt="ULU BV logo"
        />
        <img
          v-else-if="getUserSystem == 'uluuk'"
          class="sidebar-logo"
          src="@/assets/uluuk_logo.png"
          alt="ULU UK logo"
        />
        <img
          v-else-if="getUserSystem == 'Fleetify'"
          class="sidebar-logo"
          src="@/assets/fleetifyLogo.png"
          alt="Fleetify logo"
        />
        <img
          v-else-if="getUserSystem == 'Cartracker'"
          class="sidebar-logo"
          src="@/assets/cartrackerLogo.png"
          alt="Cartracker logo"
        />
        <img
          v-else-if="getUserSystem == 'traksi'"
          class="sidebar-logo"
          src="@/assets/traksi_logo.png"
          alt="Traksi logo"
        />
        <img
          v-else-if="getUserSystem == 'requre'"
          class="sidebar-logo"
          src="@/assets/requre_logo.png"
          alt="Requre logo"
        />
        <img
          v-else-if="getUserSystem == 'finnik'"
          class="sidebar-logo"
          src="@/assets/finnik_logo.png"
          alt="finnik logo"
        />
        <img
          v-else-if="getUserSystem == 'national_netherlands'"
          class="sidebar-logo"
          src="@/assets/ohra_logo.png"
          alt="national netherlands logo"
        />
        <img
          v-else-if="getUserSystem == 'imoto'"
          class="sidebar-logo"
          src="@/assets/imoto_logo.png"
          alt="imoto logo"
        />
        </div>
        <button class="hamburger-toggle" @click="toggleMinimize">
          <icon name="bars" />
        </button>
      </div>

      <!-- Navigation Menu -->
      <nav class="sidebar-nav">
        <!-- Inquiries -->
        <div
          v-if="getUserBrandPermissions.inquiries_index"
          class="nav-item-group"
        >
          <div class="nav-item" @click="handleNavClick('inquiries')">
            <icon name="file-alt" class="nav-icon"></icon>
            <span class="nav-text">{{ $t("globals.inquiries") }}</span>
            <icon :name="submenuOpen.inquiries ? 'chevron-down' : 'chevron-right'" class="nav-arrow"></icon>
          </div>
          <!-- Submenu -->
          <div v-show="submenuOpen.inquiries" class="nav-submenu">
            <router-link :to="{ name: 'allinquiries' }" class="nav-subitem">
              <icon name="list" class="subitem-icon"></icon>
              <span class="subitem-text">{{ $t("globals.all") }}</span>
            </router-link>
            <router-link
              v-if="getUserBrandPermissions.inquiry_create"
              :to="{ name: 'newinquiry' }"
              class="nav-subitem"
            >
              <icon name="plus" class="subitem-icon"></icon>
              <span class="subitem-text">{{ $t("globals.new_inquiry") }}</span>
            </router-link>
          </div>
        </div>

        <!-- Orders -->
        <router-link
          v-if="getUserBrandPermissions.orders_index"
          :to="{ name: 'allorders' }"
          class="nav-item"
        >
          <icon name="shopping-cart" class="nav-icon"></icon>
          <span class="nav-text">{{ $t("globals.orders") }}</span>
        </router-link>

        <!-- Invoices -->
        <router-link
          v-if="getUserBrandPermissions.invoices_index"
          :to="{ name: 'allinvoices' }"
          class="nav-item"
        >
          <icon name="file-invoice" class="nav-icon"></icon>
          <span class="nav-text">{{ $t("globals.invoices") }}</span>
        </router-link>

        <!-- Service -->
        <div class="nav-item-group">
          <div class="nav-item" @click="handleNavClick('service')">
            <icon name="wrench" class="nav-icon"></icon>
            <span class="nav-text">{{ $t("globals.service_service") }}</span>
            <icon :name="submenuOpen.service ? 'chevron-down' : 'chevron-right'" class="nav-arrow"></icon>
          </div>
          <!-- Submenu -->
          <div v-show="submenuOpen.service" class="nav-submenu">
            <router-link
              v-if="getUserBrandPermissions.order_service_index"
              :to="{ name: 'allservices' }"
              class="nav-subitem"
            >
              <icon name="cog" class="subitem-icon"></icon>
              <span class="subitem-text">{{ $t("globals.services_services") }}</span>
            </router-link>
            <router-link
              v-if="getUserBrandPermissions.installations_index"
              :to="{ name: 'allinstallations' }"
              class="nav-subitem"
            >
              <icon name="plug" class="subitem-icon"></icon>
              <span class="subitem-text">{{ $t("globals.installations") }}</span>
            </router-link>
            <router-link
              v-if="getUserBrandPermissions.synatec_orders_index"
              :to="{ name: 'allsynatecorders' }"
              class="nav-subitem"
            >
              <icon name="truck" class="subitem-icon"></icon>
              <span class="subitem-text">{{ $t("globals.synatec_orders") }}</span>
            </router-link>
            <router-link
              v-if="getUserBrandPermissions.devices_index"
              :to="{ name: 'alldevices' }"
              class="nav-subitem"
            >
              <icon name="mobile" class="subitem-icon"></icon>
              <span class="subitem-text">{{ $t("globals.devices") }}</span>
            </router-link>
            <router-link
              v-if="getUserBrandPermissions.terminations_index || true"
              :to="{ name: 'allterminations' }"
              class="nav-subitem"
            >
              <icon name="times-circle" class="subitem-icon"></icon>
              <span class="subitem-text">{{ $t("globals.terminations") }}</span>
            </router-link>
            <router-link
              v-if="getUserBrandPermissions.kill_list_index || true"
              :to="{ name: 'allkilllist' }"
              class="nav-subitem"
            >
              <icon name="ban" class="subitem-icon"></icon>
              <span class="subitem-text">{{ $t("globals.kill_list") }}</span>
            </router-link>
          </div>
        </div>

        <!-- Customers -->
        <router-link
          v-if="getUserBrandPermissions.customers_index"
          :to="{ name: 'allcustomers' }"
          class="nav-item"
        >
          <icon name="users" class="nav-icon"></icon>
          <span class="nav-text">{{ $t("globals.customers") }}</span>
        </router-link>
      </nav>

      <!-- Bottom Section (User Menu) -->
      <div class="sidebar-footer">
        <div class="nav-item-group">
          <div class="nav-item" @click="handleNavClick('user')">
            <icon name="user" class="nav-icon"></icon>
            <span class="nav-text user-name">
              {{ getUserName.split(" ")[0] + " " + getUserName.split(" ")[1][0] + "." }}
            </span>
            <icon :name="submenuOpen.user ? 'chevron-down' : 'chevron-right'" class="nav-arrow"></icon>
          </div>
          <!-- Submenu -->
          <div v-show="submenuOpen.user" class="nav-submenu">
            <div class="nav-subitem" @click="changeSystem">
              <icon name="desktop" class="subitem-icon"></icon>
              <span class="subitem-text">{{ $t("globals.system") }}</span>
            </div>
            <router-link
              v-if="getUserBrandPermissions.permissions_index"
              :to="{ name: 'allpermissions' }"
              class="nav-subitem"
            >
              <icon name="lock" class="subitem-icon"></icon>
              <span class="subitem-text">{{ $t("globals.permissions") }}</span>
            </router-link>
            <router-link
              v-if="getUserBrandPermissions.price_list_index"
              :to="{ name: 'allitems' }"
              class="nav-subitem"
            >
              <icon name="list" class="subitem-icon"></icon>
              <span class="subitem-text">{{ $t("globals.price_list") }}</span>
            </router-link>
            <router-link
              v-if="getUserBrandPermissions.import_tool"
              :to="{ name: 'import' }"
              class="nav-subitem"
            >
              <icon name="upload" class="subitem-icon"></icon>
              <span class="subitem-text">{{ $t("globals.import_tool") }} (beta)</span>
            </router-link>
            <router-link
              v-if="getUserBrandPermissions.customers_merge"
              :to="{ name: 'mergecustomers' }"
              class="nav-subitem"
            >
              <icon name="code-branch" class="subitem-icon"></icon>
              <span class="subitem-text">{{ $t("globals.customers_merge") }}</span>
            </router-link>
            <router-link
              v-if="getUserSystem == 'national_netherlands'"
              :to="{ name: 'ohraneworder' }"
              class="nav-subitem"
            >
              <icon name="plus" class="subitem-icon"></icon>
              <span class="subitem-text">{{ $t("globals.ohra_create_order") }}</span>
            </router-link>
            <router-link
              v-if="getUserBrandPermissions.super_admin"
              :to="{ name: 'admin' }"
              class="nav-subitem"
            >
              <icon name="user-shield" class="subitem-icon"></icon>
              <span class="subitem-text">Admin</span>
            </router-link>
            <div class="nav-subitem" @click="logOut">
              <icon name="sign-out-alt" class="subitem-icon"></icon>
              <span class="subitem-text">{{ $t("globals.signout") }}</span>
            </div>
          </div>
        </div>

        <!-- Language Selector -->
        <div class="nav-item-group">
          <div class="nav-item" @click="handleNavClick('lang')">
            <icon name="globe" class="nav-icon"></icon>
            <span class="nav-text">{{ $t("globals.lang") }}</span>
            <icon :name="submenuOpen.lang ? 'chevron-down' : 'chevron-right'" class="nav-arrow"></icon>
          </div>
          <!-- Submenu -->
          <div v-show="submenuOpen.lang" class="nav-submenu">
            <div class="nav-subitem" @click="setLocale('en')" :class="{ 'router-link-active': getLocale === 'en' }">
              <span class="lang-code">EN</span>
              <span class="subitem-text">English</span>
            </div>
            <div class="nav-subitem" @click="setLocale('nl')" :class="{ 'router-link-active': getLocale === 'nl' }">
              <span class="lang-code">NL</span>
              <span class="subitem-text">Nederlands</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ulu-system-modal />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import "vue-awesome/icons/search";
import "vue-awesome/icons/file-alt";
import "vue-awesome/icons/shopping-cart";
import "vue-awesome/icons/file-invoice";
import "vue-awesome/icons/wrench";
import "vue-awesome/icons/users";
import "vue-awesome/icons/user";
import "vue-awesome/icons/globe";
import "vue-awesome/icons/plus";
import "vue-awesome/icons/chevron-right";
import "vue-awesome/icons/chevron-down";
import "vue-awesome/icons/bars";
import "vue-awesome/icons/list";
import "vue-awesome/icons/cog";
import "vue-awesome/icons/plug";
import "vue-awesome/icons/truck";
import "vue-awesome/icons/mobile";
import "vue-awesome/icons/times-circle";
import "vue-awesome/icons/ban";
import "vue-awesome/icons/desktop";
import "vue-awesome/icons/lock";
import "vue-awesome/icons/upload";
import "vue-awesome/icons/code-branch";
import "vue-awesome/icons/user-shield";
import "vue-awesome/icons/sign-out-alt";
import "vue-awesome/icons/flag";

export default {
  components: {
    Icon: () => import("vue-awesome/components/Icon.vue"),
    "ulu-system-modal": () => import("@/components/navbar/SystemModal.vue")
  },
  data() {
    return {
      color: "#10A0D0", //Default ulu color
      isMinimized: false,
      mobileMenuOpen: false,
      submenuOpen: {
        inquiries: false,
        service: false,
        user: false,
        lang: false
      }
    };
  },
  methods: {
    ...mapActions("auth", ["logOut"]),
    ...mapMutations(["setShowSystemModal", "setLocale"]),

    defineColor() {
      switch (this.getUserSystem) {
        case "ULU":
          this.color = "#10A0D0";
          break;
        case "ulubv":
          this.color = "#10d6b3";
          break;
        case "uluuk":
          this.color = "#10A0D0";
          break;
        case "Fleetify":
          this.color = "#D88024";
          break;
        case "Cartracker":
          this.color = "#F26424";
          break;
        case "traksi":
          this.color = "#F26424";
          break;
        case "requre":
          this.color = "#F26424";
          break;
      }
    },
    changeSystem() {
      this.setShowSystemModal(true);
    },
    toggleSubmenu(menu) {
      this.submenuOpen[menu] = !this.submenuOpen[menu];
    },
    toggleMinimize() {
      // Check if on mobile
      if (window.innerWidth <= 768) {
        this.mobileMenuOpen = !this.mobileMenuOpen;
        // Close all submenus when closing mobile menu
        if (!this.mobileMenuOpen) {
          Object.keys(this.submenuOpen).forEach(key => {
            this.submenuOpen[key] = false;
          });
        }
      } else {
        this.isMinimized = !this.isMinimized;
        // Close all submenus when minimizing
        if (this.isMinimized) {
          Object.keys(this.submenuOpen).forEach(key => {
            this.submenuOpen[key] = false;
          });
        }
        // Emit event to notify parent component
        this.$root.$emit('sidebar-toggled', this.isMinimized);
      }
    },
    goToDashboard() {
      if (this.$route.name !== "dashboard") {
        this.$router.push({ name: "dashboard" });
      }
    },
    getSubmenuBackgroundColor() {
      // Create a solid background for mobile submenus
      return this.color;
    },
    handleNavClick(menu) {
      this.submenuOpen[menu] = !this.submenuOpen[menu];
    },
    handleResize() {
      // Close mobile menu when resizing to desktop
      if (window.innerWidth > 768) {
        this.mobileMenuOpen = false;
      }
    }
  },
  computed: {
    ...mapGetters([
      "getUserName",
      "getUserSystem",
      "getUserBrandPermissions",
      "getAppMode",
      "getLocale"
    ]),
    sidebarColor() {
      return {
        "background-color": this.color
      };
    }
  },
  watch: {
    getUserSystem: function() {
      this.defineColor();
    },
    $route() {
      // Close mobile menu when route changes
      if (window.innerWidth <= 768) {
        this.mobileMenuOpen = false;
        Object.keys(this.submenuOpen).forEach(key => {
          this.submenuOpen[key] = false;
        });
      }
    }
  },
  created() {
    this.defineColor();
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>

<style scoped>
.sidebar-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 210px;
  z-index: 1000;
  transition: width 0.3s ease;
}

.sidebar-wrapper.minimized {
  width: 70px;
}

.sidebar {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  overflow-x: hidden;
}

/* Mobile Responsive Styles */
@media (max-width: 768px) {
  .sidebar-wrapper {
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: auto;
    max-height: 60px;
    overflow: visible;
    z-index: 1050;
  }

  .sidebar-wrapper.minimized {
    width: 100%;
  }

  .sidebar {
    flex-direction: row;
    height: 60px;
    overflow: visible;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    position: relative;
  }

  .sidebar-header {
    flex-direction: row;
    padding: 0.75rem 1rem;
    border-bottom: none;
    border-right: 1px solid rgba(0, 0, 0, 0.1);
    width: auto;
    flex-shrink: 0;
  }

  .sidebar-logo {
    max-height: 30px;
  }

  .hamburger-toggle {
    margin-left: 0.5rem;
  }

  .sidebar-nav {
    flex-direction: row;
    padding: 0;
    overflow: visible;
    display: none;
  }

  .nav-item-group {
    margin-bottom: 0;
    position: relative;
  }

  .nav-item {
    padding: 1.25rem 1rem;
    white-space: nowrap;
  }

  .nav-submenu {
    position: absolute;
    top: 100%;
    left: 0;
    min-width: 200px;
    z-index: 1060;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }

  .sidebar-footer {
    margin-left: auto;
    display: flex;
    flex-direction: row;
    border-top: none;
    border-left: 1px solid rgba(255, 255, 255, 0.1);
    padding: 0;
    flex-shrink: 0;
    position: relative;
    align-items: center;
  }

  .sidebar-footer .nav-item-group {
    margin-bottom: 0;
    position: static;
  }

  .sidebar-footer .nav-item {
    padding: 1.25rem 1rem;
    height: 60px;
    display: flex;
    align-items: center;
  }

  .sidebar-footer .nav-submenu {
    position: fixed;
    top: 60px;
    right: 0;
    left: auto;
    min-width: 250px;
    max-height: calc(100vh - 60px);
    overflow-y: auto;
    z-index: 1060;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    background-color: var(--brand-color, #10A0D0);
  }

  /* Ensure regular nav submenus in top bar also have proper styling */
  .nav-submenu {
    max-height: calc(100vh - 80px);
    overflow-y: auto;
    background-color: var(--brand-color, #10A0D0);
  }

  /* Show simplified mobile menu */
  .sidebar-wrapper.mobile-menu-open .sidebar-nav {
    display: flex;
    position: absolute;
    top: 60px;
    left: 0;
    right: 0;
    flex-direction: column;
    background-color: inherit;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    max-height: calc(100vh - 60px);
    overflow-y: auto;
    z-index: 1055;
  }

  .sidebar-wrapper.mobile-menu-open .nav-item-group {
    margin-bottom: 0;
  }

  .sidebar-wrapper.mobile-menu-open .nav-item {
    padding: 0.875rem 1.25rem;
  }

  .sidebar-wrapper.mobile-menu-open .nav-submenu {
    position: relative;
    top: auto;
    left: auto;
    box-shadow: none;
    background-color: rgba(0, 0, 0, 0.1);
  }
}

/* Logo Section */
.sidebar-header {
  padding: 1.5rem 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  background-color: white;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.minimized .sidebar-header {
  background-color: inherit;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.logo-container {
  cursor: pointer;
  transition: opacity 0.2s;
  flex: 1;
  overflow: hidden;
}

.logo-container:hover {
  opacity: 0.9;
}

.sidebar-logo {
  max-width: 100%;
  height: auto;
  max-height: 40px;
  display: block;
  transition: opacity 0.3s ease;
}

.minimized .sidebar-logo {
  opacity: 0;
  max-height: 0;
}

.hamburger-toggle {
  background: none;
  border: none;
  color: #2c3e50;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s, color 0.3s ease;
  border-radius: 4px;
  flex-shrink: 0;
}

.hamburger-toggle:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.hamburger-toggle svg {
  width: 20px;
  height: 20px;
}

.minimized .hamburger-toggle {
  color: white;
}

.minimized .hamburger-toggle:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.minimized .sidebar-header {
  justify-content: center;
  padding: 1rem 0.5rem;
}

.minimized .logo-container {
  display: none;
}

/* Navigation */
.sidebar-nav {
  flex: 1;
  padding: 1rem 0;
  overflow-y: auto;
}

.nav-item-group {
  margin-bottom: 0.5rem;
}

.nav-item {
  display: flex;
  align-items: center;
  padding: 0.875rem 1.25rem;
  color: white;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 0.95rem;
  position: relative;
}

.nav-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.nav-item.router-link-active {
  background-color: rgba(255, 255, 255, 0.15);
  font-weight: 500;
}

.nav-icon {
  width: 20px;
  margin-right: 0.75rem;
  flex-shrink: 0;
}

.nav-text {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: opacity 0.3s ease;
}

.minimized .nav-text {
  display: none;
}

.nav-arrow {
  width: 14px;
  margin-left: auto;
  flex-shrink: 0;
  transition: opacity 0.3s ease;
}

.minimized .nav-arrow {
  display: none;
}

.nav-submenu {
  background-color: rgba(0, 0, 0, 0.1);
  padding: 0.25rem 0;
}

.minimized .nav-item {
  justify-content: center;
  padding: 0.875rem 0.5rem;
}

.minimized .nav-icon {
  margin-right: 0;
}

.nav-subitem {
  display: flex;
  align-items: center;
  padding: 0.625rem 1.25rem 0.625rem 2.625rem;
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 0.875rem;
}

.nav-subitem:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
}

.nav-subitem.router-link-active {
  background-color: rgba(255, 255, 255, 0.15);
  color: white;
  font-weight: 500;
}

.subitem-icon {
  width: 16px;
  margin-right: 0.5rem;
  flex-shrink: 0;
}

.subitem-text {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Minimized submenu styles */
.minimized .nav-subitem {
  justify-content: center;
  padding: 0.625rem 0.5rem;
}

.minimized .subitem-icon {
  margin-right: 0;
}

.minimized .subitem-text {
  display: none;
}

/* Language Code Badge */
.lang-code {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 20px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
  font-size: 0.7rem;
  font-weight: 600;
  margin-right: 0.5rem;
  flex-shrink: 0;
  letter-spacing: 0.5px;
}

.minimized .lang-code {
  width: 24px;
  height: 24px;
  margin-right: 0;
  font-size: 0.65rem;
}

/* User Section */
.sidebar-footer {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 1rem 0;
}

.user-name {
  font-weight: 500;
}

.minimized .user-name {
  display: none;
}

/* Scrollbar Styling */
.sidebar::-webkit-scrollbar {
  width: 6px;
}

.sidebar::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
}

.sidebar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
}

.sidebar::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.4);
}
</style>
